import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Alert, Glyphicon, PanelGroup, Panel, Dropdown, DropdownButton, MenuItem } from 'react-bootstrap';
import { withTranslation, Trans } from 'react-i18next';
import ReduxBlockUi from 'react-block-ui/redux';
import moment from 'moment';
import 'icheck/skins/minimal/grey.css';	// used for styling booking options accordion
import 'react-block-ui/style.css';
import utils from '../../../common/services/utils';
import ui from '../../../common/services/ui';
import MessageBox from '../../../common/components/MessageBox';
import { Link } from 'react-router-dom';

class BookingOptions extends Component {
	constructor(props) {
		super(props);

		this.handlePaymentOptionAccordionSelect = this.handlePaymentOptionAccordionSelect.bind(this);
		this.handleNewAnnualConfirm = this.handleNewAnnualConfirm.bind(this);
		this.handleNewAnnualCancel = this.handleNewAnnualCancel.bind(this);
		this.state = {
			selectedPaymentTypeKeys: {},
			pendingAnnualSelection: null
		};
	}

	componentDidMount() {
		const { bookingOptions: { date }, lessonDates, nextDate, isAuthenticated } = this.props;
		if (!date && lessonDates && lessonDates.length > 0) {
			this.props.onSelectStartDate(nextDate ? nextDate : lessonDates[0]);
		}
		if (!isAuthenticated) {
			this.props.onSelectPaymentType({ paymentTypeId: 0 });// clear selected payment type
		}
	}

	componentWillReceiveProps(nextProps) {
		// select first available start date
		if (((!this.props.bookingOptions.date && !nextProps.bookingOptions.date) ||
			//(!this.props.programId && nextProps.programId) ||
			(this.props.bookingOptions.programId && this.props.programId !== this.props.bookingOptions.programId && this.props.programId !== nextProps.bookingOptions.programId)) &&
			nextProps.lessonDates && nextProps.lessonDates.length > 0) {
			this.props.onSelectStartDate(nextProps.nextDate ? nextProps.nextDate : nextProps.lessonDates[0]);
		}

		// trigger Confirm after payment type is selected and props are updated
		if (!this.props.bookingOptions.selectedPaymentTypeId && nextProps.bookingOptions.selectedPaymentTypeId) {
			this.props.onConfirm();
		}

		// reset selected payment types in local state when new payment types are loaded
		if (this.props.bookingOptions.childrenPaymentTypes !== nextProps.bookingOptions.childrenPaymentTypes) {
			this.setState({
				selectedPaymentTypeKeys: {},
				pendingAnnualSelection: null
			});
		}
	}

	handlePaymentOptionSelect(paymentTypeId, isPrepaid, isBonusLesson, childId, annualPaymentLength) {
		this.props.onSelectPaymentType({ paymentTypeId, isPrepaid, isBonusLesson, annualPaymentLength });
		if (childId) {
			this.props.onSelectChild(childId);
		}
	}

	handlePaymentOptionButtonClick(child, paymentType, isBonusLesson, hasPrepaidAnnual) {
		// remind the parent about their existing annual payment before starting a new one
		if (hasPrepaidAnnual && paymentType.name === 'Annual' && !paymentType.isPrepaid) {
			this.setState({
				pendingAnnualSelection: {
					paymentTypeId: paymentType.id,
					isPrepaid: paymentType.isPrepaid,
					isBonusLesson,
					childId: child && child.id,
					annualPaymentLength: paymentType.annualPaymentLength,
					childName: child && child.shortName
				}
			});
		} else {
			this.handlePaymentOptionSelect(paymentType.id, paymentType.isPrepaid, isBonusLesson, child && child.id, paymentType.annualPaymentLength);
		}
	}

	handleNewAnnualConfirm() {
		const { paymentTypeId, isPrepaid, isBonusLesson, childId, annualPaymentLength } = this.state.pendingAnnualSelection;
		this.setState({ pendingAnnualSelection: null });
		this.handlePaymentOptionSelect(paymentTypeId, isPrepaid, isBonusLesson, childId, annualPaymentLength);
	}

	handleNewAnnualCancel() {
		this.setState({ pendingAnnualSelection: null });
	}

	handleJoinWaitingListSelect(childId) {
		if (childId) {
			this.props.onSelectChild(childId);
		}
		this.props.onJoinWaitingList();
	}

	renderChildrenInfo() {
		const { children, bookingOptions: { selectedChildId }, blockChildrenInfo, unblockChildrenInfo } = this.props;
		let displayChildren = children;
		if (selectedChildId) {
			displayChildren = children.filter(c => c.id === selectedChildId);
		}

		return <ReduxBlockUi block={blockChildrenInfo} unblock={unblockChildrenInfo} renderChildren={false}>
			{displayChildren.map(child => {
				const name = child.shortName;
				const classes = child.ageAppropriateGrades.map(g => g && <li key={g.id}>{g.name}</li>);
				return (
					<div key={child.id} style={{ marginBottom: '20px' }} className='suitable-classes'>
						<Trans i18nKey={child.ageAppropriateGrades.length > 0 ? 'FO_Booking_Class_AgeAppropriate' : 'FO_Booking_Class_AgeAppropriate_None'} count={child.ageAppropriateGrades.length}>
							Suitable classes for <b style={{ color: '#1d93d1' }}>{{ name }}</b>:
						</Trans>
						<ul>{classes}</ul>
					</div>
				);
			})}
		</ReduxBlockUi>;
	}

	renderErrorWithLogin(isLocked, errorMessage) {

		const { t, postTrial, isAuthenticated } = this.props;
		const showLogin = window.self === window.top && !isAuthenticated && (isLocked || postTrial);
		return <div>
			<Alert bsStyle="danger" >
				<div className='suitable-classes' dangerouslySetInnerHTML={{ __html: errorMessage }} />
				{showLogin && <div className='suitable-classes' dangerouslySetInnerHTML={{ __html: t('FO_Booking_Validation_ClassesLockedForChildToLogin') }} />}
			</Alert>
			{showLogin && <Link className='btn-block btn btn-primary' style={{ marginBottom: 5 }} to={{ pathname: '/login', state: { from: '/booking/child' } }}>{t('FO_Login_Login')} <i className='fa fa-arrow-circle-right' /></Link>}
		</div>
	}

	renderChildBookingOptions(child, paymentTypes, errorMessage, joinWaitingList, isLocked, t) {

		let allPaymentTypes = paymentTypes.map(p => { return { paymentType: p, isBonusLesson: false }; });
		// add options for bonus lessons
		paymentTypes.filter(p => p.isBonusLessonAllowed).forEach(p => allPaymentTypes.push({ paymentType: p, isBonusLesson: true }));

		const hasPrepaidAnnual = paymentTypes.some(p => p.name === 'Annual' && p.isPrepaid);
		const isMultipleOptions = allPaymentTypes.length > 1;
		const firstPaymentOption = allPaymentTypes[0];
		const accordionId = `paymentTypes_${child ? child.id : 1}`;
		const accordionDefaultActiveKey = firstPaymentOption ? this.getPaymentOptionKey(firstPaymentOption.paymentType, firstPaymentOption.isBonusLesson) : null;

		const isInIframe = window.self !== window.top;
		const { centerId, bookingOptions: { programId, date, lessonType } } = this.props;

		return <div key={child ? child.id : -1} style={{ marginBottom: '10px' }}>
			{child && <p><Glyphicon glyph='user' /> {child.shortName}</p>}
			{errorMessage && this.renderErrorWithLogin(isLocked, errorMessage)}
			{joinWaitingList &&
				<div>
					{isInIframe ? <Link target='_top' className='btn-block btn btn-primary' to={`/public/timetable/${centerId}/${programId}/wait/${lessonType || 'all'}/${date}`}>{t('FO_Booking_JoinWaitingList')} <i className='fa fa-arrow-circle-right' /></Link> :
						<Button className='btn-block btn btn-primary' onClick={() => this.handleJoinWaitingListSelect(child && child.id)}>
							{t('FO_Booking_JoinWaitingList')} <i className='fa fa-arrow-circle-right' />
						</Button>}
				</div>
			}
			{!joinWaitingList && <PanelGroup
				accordion id={accordionId}
				defaultActiveKey={accordionDefaultActiveKey}
				onSelect={activeKey => this.handlePaymentOptionAccordionSelect(accordionId, activeKey)}
			>
				{allPaymentTypes.map(p => this.renderPaymentOption(child, p.paymentType, p.isBonusLesson, accordionId, accordionDefaultActiveKey, isMultipleOptions, hasPrepaidAnnual, t))}
			</PanelGroup>
			}
		</div>;
	}

	getPaymentOptionKey(paymentType, isBonusLesson) {
		const annualPaymentLengthSuffix = paymentType.annualPaymentLength ? `_${paymentType.annualPaymentLength}` : '';
		return `${paymentType.id}${paymentType.isPrepaid ? '_Prepaid' : ''}${isBonusLesson ? '_Bonus' : ''}${annualPaymentLengthSuffix}`;
	}

	handlePaymentOptionAccordionSelect(accordionId, activeKey) {
		this.setState({
			selectedPaymentTypeKeys: {
				...this.state.selectedPaymentTypeKeys,
				[accordionId]: activeKey
			}
		});
	}

	renderPaymentOption(child, paymentType, isBonusLesson, accordionId, defaultAccordionKey, isMultipleOptions, hasPrepaidAnnual, t) {
		const key = this.getPaymentOptionKey(paymentType, isBonusLesson);
		const selectedKey = this.state.selectedPaymentTypeKeys[accordionId];
		const isSelected = selectedKey ? key === selectedKey : key === defaultAccordionKey;

		const isInIframe = window.self !== window.top;
		const { centerId, bookingOptions: { programId, date, lessonType } } = this.props;

		return <Panel key={key} eventKey={key} className='booking-option'>
			<Panel.Heading className={isSelected ? 'checked' : ''}>
				<Panel.Title toggle={!isSelected} className={isMultipleOptions ? 'radio' : ''} >
					{isMultipleOptions && <div className={`iradio_minimal-grey radio-icon ${isSelected ? 'checked' : ''}`} />}
					{this.renderPaymentOptionContent(paymentType, isBonusLesson, t)}
				</Panel.Title>
			</Panel.Heading>
			<Panel.Body collapsible>
				{isInIframe ? <Link target='_top' className='btn-block btn btn-primary' to={`/public/timetable/${centerId}/${programId}/book/${lessonType || 'all'}/${date}/${paymentType.id}/${paymentType.annualPaymentLength || 1}/${paymentType.isPrepaid ? 1 : 0}/${isBonusLesson ? 1 : 0}`}>{t('FO_Booking_BookingOptions_Select')} <i className='fa fa-arrow-circle-right' /></Link> :
					<Button className='btn-block btn btn-primary' onClick={() => this.handlePaymentOptionButtonClick(child, paymentType, isBonusLesson, hasPrepaidAnnual)}>
						{t('FO_Booking_BookingOptions_Select')} <i className='fa fa-arrow-circle-right' />
					</Button>}
			</Panel.Body>
		</Panel>;
	}

	renderNewAnnualConfirmation() {
		const { t, enableAnnualSubscriptionInstalments } = this.props;
		const { pendingAnnualSelection } = this.state;
		const resourceSuffix = enableAnnualSubscriptionInstalments ? '_Subscription' : '';

		return <MessageBox
			show={!!pendingAnnualSelection}
			title={t(`FO_Booking_NewAnnualConfirmation_Title${resourceSuffix}`)}
			message={t(`FO_Booking_NewAnnualConfirmation_Message${resourceSuffix}`, { name: pendingAnnualSelection && pendingAnnualSelection.childName })}
			confirmText={t('FO_Booking_NewAnnualConfirmation_Continue')}
			cancelText={t('FO_Booking_NewAnnualConfirmation_Cancel')}
			onConfirm={this.handleNewAnnualConfirm}
			onCancel={this.handleNewAnnualCancel} />;
	}

	renderPaymentOptionContent(paymentType, isBonusLesson, t) {
		const { currentCurrency, franchisorCurrency, enableCurrencyConversion } = this.props;

		const conversionLink = ui.getCurrencyConversionLink(enableCurrencyConversion, currentCurrency, franchisorCurrency, paymentType.totalAmount);

		return <div>
			<div className='payment-type'>
				<span style={{ float: 'left' }}>{t(paymentType.displayNameResource, { count: paymentType.name === 'Annual' ? paymentType.annualPaymentLength : 1 })}{isBonusLesson ? `- ${t('FO_Booking_Form_IsBonusLesson')}` : ''}</span>
				<div className='clearfix' />
			</div>
			<div className='price'>
				<span style={{ float: 'left', fontSize: '14px' }}>{paymentType.monthlyInstalment ? t('FO_Booking_BookingOptionMonthlyInstalment', { amount: paymentType.monthlyInstalment }) :
					paymentType.hideUnitPrice ? t('FO_Booking_BookingOptionTotal') : `${paymentType.quantity} x ${paymentType.unitPrice}`}</span>
				{!paymentType.hideTotal && <span style={{ float: 'right' }}>{paymentType.total}</span>}
				<div className='clearfix' />
				{conversionLink && !paymentType.hideTotal &&
					<a href={conversionLink} target='_blank' className='currency-conversion' style={{ float: 'right' }}>{t('FO_Common_ConvertToCurrency', { currency: currentCurrency })}</a>}
				<div className='clearfix' />
			</div>
		</div>;
	}

	renderLessonBookingOptions() {
		const { t, block, unblock, bookingOptions: { errorMessage, selectedChildId, selectedPaymentTypeId, annualPaymentLength, childrenPaymentTypes, warningMessage } } = this.props;

		const selectedChild = selectedChildId && childrenPaymentTypes.find(c => c.child && c.child.id === selectedChildId);
		const visibleChildren = selectedChild ? [selectedChild] : childrenPaymentTypes;

		if (errorMessage) {
			return this.renderErrorWithLogin(false, errorMessage)
		}

		const selectedPaymentType = selectedChild && selectedPaymentTypeId && selectedChild.paymentTypes.find(p => p.id === selectedPaymentTypeId && (!annualPaymentLength || p.annualPaymentLength === annualPaymentLength));

		return (
			<ReduxBlockUi block={block} unblock={unblock} renderChildren={false}>
				{warningMessage && <Alert bsStyle="warning" >
					<div className='suitable-classes' dangerouslySetInnerHTML={{ __html: warningMessage }} />
				</Alert>}
				{selectedPaymentType ? <div><p><Glyphicon glyph='user' /> {selectedChild.child.shortName}</p><p>{t(selectedPaymentType.displayNameResource, { count: selectedPaymentType.name === 'Annual' ? selectedPaymentType.annualPaymentLength : 1 })}</p></div> : visibleChildren.map(x => this.renderChildBookingOptions(x.child, x.paymentTypes, x.errorMessage, x.joinWaitingList, x.isLocked, t))}
			</ReduxBlockUi>
		);
	}

	renderStartDateSelector() {
		const { lessonDates, bookingOptions, nextDate, enableUserTimeZone, center, t } = this.props;

		return <div style={{ marginBottom: '20px' }}>
			{lessonDates.length === 0 ?
				<Alert bsStyle='danger'>{t('FO_Booking_Form_NoUpcomingClasses')}</Alert> :
				lessonDates.length === 1 ?
					<div>
						<p>{t('FO_Booking_Form_StartDateFixed')}</p>
						<p style={{ fontWeight: 'bold', color: '#1d93d1' }}>
							{(enableUserTimeZone ? utils.convertToUserTime(nextDate ? nextDate : lessonDates[0], center) : moment(nextDate ? nextDate : lessonDates[0])).format('LL, dddd')}
						</p>
					</div> :
					<div>
						<p>{t('FO_Booking_Form_StartDate')}</p>
						<Dropdown id='selectStartDate' onSelect={key => this.props.onSelectStartDate(key)} className='btn-block'>
							<Dropdown.Toggle className='btn-block'>{bookingOptions.date ? (enableUserTimeZone ? utils.convertToUserTime(bookingOptions.date, center) : moment(bookingOptions.date)).format('LL, dddd') : t('FO_BookingOptions_SelectDate')}</Dropdown.Toggle>
							<Dropdown.Menu className='btn-block'>{lessonDates.map(date => <MenuItem key={date} eventKey={date}>{(enableUserTimeZone ? utils.convertToUserTime(date, center) : moment(date)).format('LL, dddd')}</MenuItem>)}</Dropdown.Menu>
						</Dropdown>
					</div>}
		</div>;
	}

	render() {
		const { t } = this.props;

		return <div className='booking-options-container' style={{ width: '100%', margin: 0, marginBottom: 20 }}>
			<h3>{t('FO_Booking_BookingOptions_Title')}</h3>
			{this.renderStartDateSelector()}
			{this.renderLessonBookingOptions()}
			{this.renderNewAnnualConfirmation()}
		</div>;
	}
}

BookingOptions.propTypes = {
	bookingOptions: PropTypes.shape({
		warningMessage: PropTypes.string,
		errorMessage: PropTypes.string,
		childrenPaymentTypes: PropTypes.arrayOf(PropTypes.shape({
			child: PropTypes.shape({
				fullName: PropTypes.string
			}),
			paymentTypes: PropTypes.arrayOf(PropTypes.shape({
				id: PropTypes.number,
				isPrepaid: PropTypes.bool,
				displayNameResource: PropTypes.string,
				annualPaymentLength: PropTypes.number,
				isFree: PropTypes.bool,
				isBonusLessonAllowed: PropTypes.bool,
				hideUnitPrice: PropTypes.bool,
				hideTotal: PropTypes.bool
			})),
			errorMessage: PropTypes.string,
			joinWaitingList: PropTypes.bool,
			isLocked: PropTypes.bool
		})),
		programId: PropTypes.number,
		date: PropTypes.string,
		selectedChildId: PropTypes.number,
		selectedPaymentTypeId: PropTypes.number,
		isSelectJoinWaitingList: PropTypes.bool,
		isBonusLesson: PropTypes.bool,
		annualPaymentLength: PropTypes.number
	}),
	children: PropTypes.arrayOf(PropTypes.shape({
		shortName: PropTypes.string,
		hasTrialLesson: PropTypes.boolean,
		ageAppropriateGrades: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.number, name: PropTypes.string }))
	})),
	lessonDates: PropTypes.arrayOf(PropTypes.string),
	nextDate: PropTypes.date,
	enableAnnualSubscriptionInstalments: PropTypes.bool,
	onSelectStartDate: PropTypes.func.isRequired,
	onSelectPaymentType: PropTypes.func.isRequired,
	onJoinWaitingList: PropTypes.func.isRequired,
	onSelectChild: PropTypes.func,
	onConfirm: PropTypes.func.isRequired
};

export default withTranslation()(BookingOptions);